export const locations = {
  'ushuaia': { 
    lat: -54.8, 
    lng: -68.3, 
    zoom: 10, 
    date: 'February 26, 2025', 
    description: 'The journey begins at the southernmost city in the world, Ushuaia, the gateway to Antarctica.', 
    photoCount: 3,
    photos: [
      './photos/ushuaia/city-view.jpeg',  // Changed from /photos to ./photos
      './photos/ushuaia/port.jpeg',
      './photos/ushuaia/mountains.jpeg'
    ]
  },
  'Beaggle_channel_s': { 
    lat: -55.13, 
    lng: -66.66
  },
  'drake_passage': { 
    lat: -61.46, 
    lng: -67.79, 
    zoom: 5,  
    date: 'February 27 - March 1, 2025', 
    description: 'Navigating the legendary Drake Passage towards the Antarctic Circle.', 
    photoCount: 3,
    photos: [
      './photos/drake/waves.jpeg',
      './photos/drake/seabirds.jpeg',
      './photos/drake/dolphins.jpeg'
    ]
  },
  'antarctic_circle': { 
    lat: -63.162, 
    lng: -66.552, 
    zoom: 7, 
    date: 'March 1st, approx 11:00 am', 
    description: 'A significant milestone: crossing the latitude of 66°33.5′ S southbound!', 
    photoCount: 3,
    photos: [
      '/photos/circle/crossing.jpeg',
      '/photos/circle/celebration.jpeg',
      '/photos/circle/view.jpeg'
    ]
  },
  'marguerite_entry': { 
    lat: -67.5, 
    lng: -69.35,
    zoom: 7
  },
  'red_rock_ridge': { 
    lat: -68.3, 
    lng: -67.1, 
    zoom: 12, 
    date: 'March 2, 2025 (AM)', 
    description: "First continental landing after crossing the Circle! Activities included a landing and Zodiac cruise. Furthest point south reached during the expedition (approx. 68º17.44'S, 67º10.07'W in Marguerite Bay).", 
    photoCount: 3,
    photos: [
      '/photos/red-rock/landing.jpeg',
      '/photos/red-rock/zodiac.jpeg',
      '/photos/red-rock/landscape.jpeg'
    ]
  },
  'stonington_island': { 
    lat: -68.18, 
    lng: -67.0, 
    zoom: 12, 
    date: 'March 2, 2025 (PM)', 
    description: 'Explored via Zodiac cruise, with opportunities for day paddling and kayaking near this historic former base location.', 
    photoCount: 3,
    photos: [
      '/photos/stonington/kayak.jpeg',
      '/photos/stonington/base.jpeg',
      '/photos/stonington/seals.jpeg'
    ]
  },
  'horseshoe_island': { 
    lat: -67.80, 
    lng: -67.2, 
    zoom: 12, 
    date: 'March 3, 2025 (AM)', 
    description: 'Activities included a landing, Zodiac cruise, Stand-Up Paddleboarding (SUP), and the exhilarating Polar Plunge!', 
    photoCount: 3,
    photos: [
      '/photos/horseshoe/name.jpeg',
      '/photos/horseshoe/stone.jpeg',
      '/photos/horseshoe/inside.jpeg'
    ]
  },
  'marguerite_bay': { 
    lat: -67.5, 
    lng: -69.35, 
    zoom: 9, 
    date: 'March 3, 2025 (PM)', 
    description: 'Cruising through the scenic and expansive Marguerite Bay, venturing further south.', 
    photoCount: 3,
    photos: [
      '/photos/marguerite/bay.jpeg',
      '/photos/marguerite/ice.jpeg',
      '/photos/marguerite/sunset.jpeg'
    ]
  },
  'west_adelaide': { 
    lat: -67.0, 
    lng: -68.5 
  },
  'crystal_sound': { 
    lat: -66.6, 
    lng: -67.2, 
    zoom: 10, 
    date: 'March 4, 2025 (AM)', 
    description: 'Experienced an ice landing, Zodiac cruising, kayaking, and day paddling in the stunning, ice-filled Crystal Sound.', 
    photoCount: 3,
    photos: [
      '/photos/crystal/ice-landing.jpeg',
      '/photos/crystal/emperor.jpeg',
      '/photos/crystal/iceberg.jpeg'
    ]
  },
  'gerlache_n': { 
    lat: -65.5, 
    lng: -65.0 
  },
  'danco_coast': { 
    lat: -64.9, 
    lng: -64.0, 
    zoom: 9, 
    date: 'March 5, 2025 (AM)', 
    description: 'Ship cruising along the dramatic Danco Coast, known for its mountainous terrain and glaciers meeting the sea.', 
    photoCount: 3,
    photos: [
      '/photos/danco/mountains.jpeg',
      '/photos/danco/glaciers.jpeg',
      '/photos/danco/coastal.jpeg'
    ]
  },
  'cuverville_island': { 
    lat: -64.68, 
    lng: -62.63, 
    zoom: 12, 
    date: 'March 6, 2025 (AM)', 
    description: 'Landing and Zodiac cruising around Cuverville Island, famous for its large Gentoo penguin colony.', 
    photoCount: 3,
    photos: [
      '/photos/cuverville/penguins.jpeg',
      '/photos/cuverville/island.jpeg',
      '/photos/cuverville/zodiac.jpeg'
    ]
  },
  'paradise_harbour': { 
    lat: -64.82, 
    lng: -62.87, 
    zoom: 12, 
    date: 'March 6, 2025 (PM)', 
    description: 'Zodiac cruising in the breathtakingly beautiful Paradise Harbour, surrounded by glaciers and ice cliffs.', 
    photoCount: 3,
    photos: [
      '/photos/paradise/harbour.jpeg',
      '/photos/paradise/cliffs.jpeg',
      '/photos/paradise/penguins.jpeg'
    ]
  },
  'palaver_point': { 
    lat: -64.14, 
    lng: -61.75, 
    zoom: 12, 
    date: 'March 7, 2025 (AM)', 
    description: 'Final landing of the expedition at Palaver Point, involving a landing, Zodiac cruise, and day paddling.', 
    photoCount: 3,
    photos: [
      '/photos/palaver/landing.jpeg',
      '/photos/palaver/paddling.jpeg',
      '/photos/palaver/chinstrap.jpeg'
    ]
  },
  'north_shetlands': { 
    lat: -63.0, 
    lng: -61.0 
  },
  'drake_passage_return': { 
    lat: -61.95, 
    lng: -62.39, 
    zoom: 6,  // Changed from 5 to 6 for better visibility
    date: 'March 8 - 9, 2025', 
    description: 'Heading north back across the Drake Passage towards Ushuaia, reflecting on the incredible journey.', 
    photoCount: 3,
    photos: [
      './photos/drake-return/waves.jpeg',
      './photos/drake-return/albatross.jpeg',
      './photos/drake-return/people.jpeg'
    ]
  },
  'Beaggle_channel_n': { 
    lat: -55.13, 
    lng: -66.66 
  },
  'ushuaia_end': { 
    lat: -54.8, 
    lng: -68.3, 
    zoom: 10, 
    date: 'March 10, 2025', 
    description: 'The expedition concludes back in Ushuaia.', 
    photoCount: 3,
    photos: [
      '/photos/ushuaia-return/group.jpeg',
      '/photos/ushuaia-return/city.jpeg',
      '/photos/ushuaia-return/sunset.jpeg'
    ]
  }
};

export const locationOrder = [
  'ushuaia',
  'Beaggle_channel_s',
  'drake_mid1',
  'drake_mid2', 
  'drake_passage',
  'antarctic_circle',
  'marguerite_entry',
  'marguerite_mid',
  'red_rock_ridge',
  'stonington_island',
  'horseshoe_island',
  'marguerite_bay',
  'west_adelaide',
  'crystal_mid',
  'crystal_sound',
  'gerlache_mid',
  'gerlache_n',
  'danco_coast',
  'cuverville_island',
  'paradise_harbour',
  'palaver_point',
  'north_shetlands',
  'drake_return_mid1',
  'drake_return_mid2',
  'drake_passage_return',
  'Beaggle_channel_n',
  'ushuaia_end'
];

export const expeditionInfo = {
  title: 'Antarctic Expedition: Below the Circle',
  dates: '26 February 2025 - 10 March 2025',
  vessel: 'M/V Ocean Endeavor'
};
